<template>
  <div v-bem>
    <div v-if="!$screen.lg" v-bem:triggers>
      <button
        v-bem:trigger="{ isActive: activeTab === 'login' }"
        @click="activeTab = 'login'"
      >
        {{ t('Accord Login') }}
      </button>
      <button
        v-bem:trigger="{ isActive: activeTab === 'doccheck' }"
        @click="activeTab = 'doccheck'"
      >
        {{ t('DocCheck Login') }}
      </button>
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div v-if="$screen.lg || activeTab === 'login'" v-bem:pane>
      <h2 v-if="$screen.lg" v-bem:heading>{{ t('Accord Login') }}</h2>
      <div v-html="loginFormHtml" />
    </div>
    <div v-if="$screen.lg || activeTab === 'doccheck'" v-bem:pane>
      <h2 v-if="$screen.lg" v-bem:heading>{{ t('DocCheck Login') }}</h2>
      <div>
        <iframe
          id="dc_login_iframe"
          name="dc_login_iframe"
          frameborder="0"
          scrolling="no"
          :width="doccheckIFrameAttributes.width"
          :height="doccheckIFrameAttributes.height"
          :src="doccheckIFrameAttributes.url"
        >
          <a :href="doccheckLoginBaseUrl" target="_blank">LOGIN</a>
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

const iFrameConfigs = {
  small: {
    width: 156,
    height: 203,
    template: 's_red',
  },
  medium: {
    width: 311,
    height: 188,
    template: 'm_red',
  },
  large: {
    width: 467,
    height: 231,
    template: 'xl_red',
  },
};

export default {
  name: 'Login',
  data() {
    return {
      activeTab: 'login',
    };
  },
  computed: {
    ...mapState('pageHeader', ['loginFormHtml', 'doccheckLoginBaseUrl']),
    doccheckIFrameAttributes() {
      let size = 'small';

      if (this.$screen.width > 343) {
        size = 'medium';
      }

      if (this.$screen.width > 499) {
        size = 'large';
      }

      const config = iFrameConfigs[size];

      return {
        ...config,
        url: [this.doccheckLoginBaseUrl, config.template].join('/'),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use 'sass:map';

.login {
  width: 100%;

  @include utils.bs-media-breakpoint-up(lg) {
    display: flex;
    max-width: 900px;
    margin: 0 auto;
    padding: utils.f-rem-calc(20) 0;
  }

  @at-root #{&}__triggers {
    display: flex;
    gap: utils.f-rem-calc(16);
    margin-bottom: utils.f-rem-calc(32);
  }

  @at-root #{&}__trigger {
    display: block;
    margin: 0;
    padding: 0;
    border: none;
    background-color: transparent;
    font-size: utils.f-convert-to-rem(20);
    font-weight: 500;
    opacity: 0.3;
    transition: all 320ms;
    cursor: pointer;

    &:focus {
      outline: none;
    }

    @at-root {
      &:hover,
      #{&}--is-active {
        opacity: 1;
      }
    }
  }

  @at-root #{&}__pane {
    flex: 0 0 50%;
    padding-right: utils.f-rem-calc(30);
  }

  @at-root #{&}__heading {
    margin-bottom: utils.f-rem-calc(32);
    font-size: utils.f-rem-calc(34);
    font-weight: 600;
    color: map.get(utils.$v-colors, acc-black);
    line-height: 1em;
  }
}
</style>
